export default __webpack_public_path__ + "media/images/backgrounds/brown-waves-6038cbf5440e123ff4b8eaac36eaa646.svg";